// eslint-disable-next-line import/prefer-default-export
export { Icon } from '@adobe/react-spectrum';
